import React, {
	memo,
	RefObject,
	useCallback,
	useRef,
	useState,
	ChangeEvent,
} from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import cuid from 'cuid'
import Button from '@material-ui/core/Button'
import { Grid } from '@material-ui/core'
import PublishIcon from '@material-ui/icons/Publish'
import Fab from '@material-ui/core/Fab'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import Chip from '@material-ui/core/Chip'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

import styles from '../styles'
import { UserOnboardingStateValue } from '../reducer'
// import { JobEditor } from './'
import { StoreValue } from 'store'
import { SIGN_REQUEST_URIS, buildUserCvFile } from 'utils'
import { EUserOnboardingActionTypes, EAppStateActionTypes } from 'models'
import { useSetUpProfileMutation } from '../../../../src/graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const Step4View: React.FunctionComponent<any> = props => {
	const {
		userCv,
		handleBack,
		storeUserProfileId,
		firstName,
		lastName,
		aboutName,
		imageProfile,
		imageAvatar,
		skills,
		values,
		experience,
		storeUserUid,
		storeUserId,
		userOnBoardDispatch,
		storeDispatch,
	} = props
	const {
		// title,
		// description,
		// startDatetime,
		// endDatetime,
		location,
		// company,
		// position,
		// isCurrent,
		// isPresent,
	} = experience
	const classes = useStyles()
	const history = useHistory()
	const { t, i18n } = useTranslation()
	const uploadInput: RefObject<HTMLInputElement> = useRef(null)
	const [stage, setStage] = useState(userCv ? 4 : 0)
	const [percent, update] = useState(0)
	// const [fileName, setFileName] = useState('')
	// const fileExtension = '-user-original.pdf'
	const triggerFileSelect = useCallback(() => {
		if (uploadInput && uploadInput.current) uploadInput.current.click()
	}, [uploadInput])

	const getSkills = useCallback(skills => {
		// skills from reducer are stored in an array with different keys
		const resultSkills = skills?.map((item: any) => {
			return item.value
		})
		return resultSkills
	}, [])

	// Todo Kundan1023
	const [setUpProfileHandle] = useSetUpProfileMutation({
		variables: {
			profileId: storeUserProfileId,
			firstName,
			lastName,
			aboutMe: aboutName,
			avatarPath: imageProfile,
			coverPath: imageAvatar,
			skills: getSkills(skills),
			values,
			locationId: location ? location : undefined,
			//Todo missing key: experience key missing
			// experience: {
			// 	locationId: location ? location : undefined,
			// 	isCurrent: isCurrent ? isCurrent : undefined,
			// 	isPresent: isPresent ? isPresent : undefined,
			// 	position: position ? position : undefined,
			// 	company: company ? company : undefined,
			// 	startDate: startDatetime ? startDatetime : undefined,
			// 	endDate: endDatetime ? endDatetime : undefined,
			// 	title: title ? title : undefined,
			// 	description: description ? description : undefined,
			// },
			cvFilePath: userCv.name ? [userCv.name] : undefined,
			cvFileOriginalName: userCv.originalName
				? [userCv.originalName]
				: undefined,
		},
	})
	const saveProfile = useCallback(() => {
		setUpProfileHandle().then(() => {
			history.push(`/${i18n.language}/people/${storeUserUid}`)
		})
	}, [setUpProfileHandle, history, i18n, storeUserUid])
	const handleFileSelect = useCallback(
		(ev: ChangeEvent<HTMLInputElement>) => {
			setStage(1)
			const source: any =
				uploadInput &&
				uploadInput.current &&
				uploadInput.current.files &&
				uploadInput.current.files[0]
			const blob = source.slice(0, source.size, source.type)
			const fileId = cuid()
			// setFileId(fileId)
			const file = new File([blob], `${fileId}${source.name}`, {
				type: source.type,
			})
			const params = {
				userId: storeUserId,
				fileName: file && file.name,
				contentType: file && file.type,
				environment: process.env.REACT_APP_ENVIRONMENT,
				type: 'user',
			}
			axios({
				method: 'post',
				// @ts-ignore
				url: SIGN_REQUEST_URIS[process.env.REACT_APP_ENVIRONMENT],
				data: params,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
				.then(({ data: { signedUrl } }: any) => {
					setStage(3)
					var options = {
						headers: {
							'Content-Type': file && file.type,
						},
						onUploadProgress: (progressEvent: any) => {
							let newPercent: any =
								(progressEvent.loaded / progressEvent.total) *
								100
							if (newPercent > 100) newPercent = 100
							update(newPercent.toFixed(0))
						},
					}
					axios
						.put(signedUrl, file, options)
						.then(() => {
							userOnBoardDispatch({
								type: EUserOnboardingActionTypes.setUserCv,
								userCv: {
									name: file.name,
									originalName: source.name,
								},
							})
							// TODO: Temporary solution...
							storeDispatch({
								type: EAppStateActionTypes.setUserCvFile,
								userCv: {
									cvFilePath: [file.name],
									cvFileOriginalName: [source.name],
								},
							})
							setStage(4)
						})
						.catch(error => {
							console.error(error)
						})
				})
				.catch(error => {
					setStage(2)
					console.error(error)
				})
		},
		[storeUserId, userOnBoardDispatch, storeDispatch],
	)
	const handleOpenCvFile = useCallback(() => {
		window.open(buildUserCvFile(storeUserId, userCv.name), '_blank')
	}, [storeUserId, userCv])
	const handleDeleteCvFile = useCallback(() => {
		userOnBoardDispatch({
			type: EUserOnboardingActionTypes.setUserCv,
			userCv: {
				name: '',
				originalName: '',
			},
		})
		// TODO: Temporary solution...
		storeDispatch({
			type: EAppStateActionTypes.setUserCvFile,
			userCv: {
				cvFilePath: [],
				cvFileOriginalName: [],
			},
		})
		setStage(0)
	}, [userOnBoardDispatch, storeDispatch])
	// const isNotValidStep = useCallback(() => {
	// 	return _.isEmpty(userCv)
	// }, [userCv])

	let uploadText: any = ''
	switch (stage) {
		case 1:
			uploadText = t('Preparing ...')
			break
		case 2:
			uploadText = t('Something went wrong ... try again')
			break
		case 3:
			uploadText = t('Uploading ... ') + percent + '%'
			break

		default:
			uploadText = (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexFlow: 'column',
					}}
				>
					<PublishIcon fontSize={'large'} />
					<div>{t('Upload your CV')}</div>
				</div>
			)
	}
	return (
		<div>
			<Grid container direction={'row'}>
				<Grid item xs={12}>
					<div className={classes.uploadCvWrap}>
						<input
							onChange={handleFileSelect}
							ref={uploadInput}
							type="file"
							style={{ display: 'none' }}
						/>

						{stage !== 4 ? (
							<>
								<input
									onChange={handleFileSelect}
									ref={uploadInput}
									type="file"
									style={{ display: 'none' }}
								/>
								<Button
									color="primary"
									className={classes.cvUploadBtn}
									onClick={triggerFileSelect}
								>
									{uploadText}
								</Button>
								<div
									style={{
										marginBottom: 10,
									}}
								>
									{t(
										'This way Companies can easily access and discover your work history',
									)}
								</div>
							</>
						) : (
							<>
								<Chip
									onClick={handleDeleteCvFile}
									style={{ background: '#fff' }}
									icon={<DeleteOutlinedIcon />}
									variant="outlined"
									color={'secondary'}
									clickable={true}
									classes={{
										label: classes.deleteIconLabel,
										root: classes.deleteRootElement,
									}}
								/>
								<div
									style={{
										// maxWidth: 300,
										maxHeight: 300,
										alignSelf: 'center',
										padding: '25px',
										cursor: 'pointer',
									}}
									onClick={handleOpenCvFile}
								>
									{userCv && userCv.originalName}
								</div>
							</>
						)}
					</div>
				</Grid>
				<Grid item xs={12}>
					<div className={classes.btnsContainer}>
						<Button onClick={handleBack}>{t('Back')}</Button>
						<Fab
							onClick={saveProfile}
							className={classes.nextBtn}
							variant="extended"
							size="medium"
							color="primary"
							aria-label="Add"
						>
							{t('Save') || ''}
						</Fab>
					</div>
				</Grid>
			</Grid>
		</div>
	)
}

const Step4WithStoreValue = (props: any) => (
	<StoreValue
		keys={[
			'user.id|storeUserId',
			'user.uid|storeUserUid',
			'user.profile.id|storeUserProfileId',
			'storeDispatch',
		]}
	>
		<Step4View {...props} />
	</StoreValue>
)

const Step4 = memo((props: any) => (
	<UserOnboardingStateValue
		keys={[
			'id',
			'userOnBoardDispatch',
			'firstName',
			'lastName',
			'aboutMe',
			'imageProfile',
			'imageAvatar',
			'skills',
			'values',
			'experience',
			'userCv',
		]}
	>
		<Step4WithStoreValue {...props} />
	</UserOnboardingStateValue>
))

export default Step4
